import { InputNumber } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

const NumericInput = ({
  value,
  onChange,
  placeholder = '',
  disabled = false,
}) => {
  // Local state to avoid re-rendering the entire form on every keystroke
  const [localValue, setLocalValue] = useState(value);
  const debounceRef = useRef(null);

  // Sync local state when external value changes (e.g., reset form)
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (newValue) => {
    setLocalValue(newValue);

    // Debounce: propagate to parent after 300ms of inactivity
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      onChange?.(newValue);
    }, 300);
  };

  // Propagate immediately on blur (in case user clicks away before debounce fires)
  const handleBlur = () => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    onChange?.(localValue);
  };

  return (
    <div style={{ width: '100%' }}>
      <InputNumber
        style={{ width: '100%' }}
        placeholder={placeholder || 'Entrez une valeur numérique'}
        value={localValue}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
      />
    </div>
  );
};

export default NumericInput;
